<template>
  <div>
    <f-model :visible="visible" width="400px" :showclose="false">
      <div class="resetPassword f-model-body" slot="body">
        <div class="input_item">
          <el-input v-model="resetData.phone" placeholder="手机号"></el-input>
        </div>
        <div class="input_item">
          <el-input
            v-model="resetData.password"
            show-password
            placeholder="新的密码"
          ></el-input>
        </div>
        <div class="input_item">
          <el-input
            v-model="resetData.code"
            placeholder="输入4位短信验证码"
          ></el-input>
          <sendcode
            ref="code"
            class="code"
            @click.native="sendcode()"
          ></sendcode>
        </div>
        <div class="f-mode-footer">
          <a class="no" @click="cancel()">取消</a>
          <a class="yes" @click="resetPassword()">确认修改</a>
        </div>
      </div>
    </f-model>
  </div>
</template>

<script>
import { resetP } from '@/api';
import { CheckInput } from '@/utils/Tools';
import sendcode from '../loginModel/sendPassCode.vue';
export default {
  name: 'resetPassword',
  components: {
    sendcode
  },
  data() {
    return {
      resetData: {
      }
    };
  },
  computed: {
    visible() {
      return this.$store.state.resetvisible;
    },
    userInfo() {
      return this.$store.state.userInfo || '';
    }
  },
  methods: {
    sendcode() {
      this.$refs.code.sendcode(this.resetData.phone);
    },
    cancel() {
      this.resetData = {};
      this.$refs.code.reset();
      this.$store.commit('setResetVisible', false);
    },
    resetPassword() {
      if (this.resetData.phone === '' || !CheckInput('telReg', this.resetData.phone)) {
        this.$message.error('请输入正确电话号码');
        return;
      }
      if (this.resetData.password === '') {
        this.$message.error('请输入新密码');
        return;
      }
      if (this.resetData.code === '') {
        this.$message.error('请输入验证码');
        return;
      }
      resetP(Object.assign({}, this.resetData, { userId: this.userInfo.userId })).then(res => {
        console.log(res);
        if (res.code === 0) {
          this.$message.success('修改成功');
          this.cancel();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.resetPassword {
  width: 400px;
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/resetPassword/index.vue